import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center xl:space-x-6 xl:text-xl space-x-4 text-base" }
const _hoisted_2 = ["data-cy", "onClick"]
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "flex-col flex-no-wrap w-56" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "flex justify-start flex-wrap text-gray-600" }
const _hoisted_7 = { class: "text-gray-800" }
const _hoisted_8 = { class: "flex flex-col w-46" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row flex-no-wrap space-x-2"
}
const _hoisted_10 = { class: "text-gray-600" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-row flex-no-wrap space-x-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600" }, " NHS ", -1)
const _hoisted_13 = { class: "flex flex-col w-46" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col justify-center px-2"
}
const _hoisted_15 = {
  key: 1,
  class: "flex justify-center px-2"
}

import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import DataTable from '@/lib/components/DataTable/DataTable.vue';
import { ExternalPatientSearchResult, MPIPatient } from '@/models';
import { IColumn } from '@/lib';
import BaseButton from '@/lib/components/Button/BaseButton.vue';
import { getDobFromISOString } from '@/helpers/patient.helper';
import { genderOptions } from '@/constants';
import { MedKitBadge } from '@bigpicturemedical/medkit';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientResults',
  props: {
  loading: {
    type: Boolean,
    default: false
  },
  searchResult: {
    type: Array as PropType<Array<ExternalPatientSearchResult>>,
    default: null
  },
  searchTypeIndex: {
    type: Number,
    required: true
  },
  showPatientResultsTable: {
    type: Boolean,
    default: true
  }
},
  emits: ["view-patient", "select-patient", "update-search-type"],
  setup(__props, { emit: __emit }) {

const { d } = useI18n();
const props = __props;
const emit = __emit;

const columns: IColumn[] = [
  { name: 'patient', label: 'Patient', sortable: false },
  { name: 'ids' },
  { name: 'postcode', label: 'Postcode' },
  { name: 'buttons' }
];

const isPDSSearch = computed<boolean>(() => props.searchResult[props.searchTypeIndex].type === 'SPINE');
const tableRows = computed(() => props.searchResult[props.searchTypeIndex].rows.map((patient) => ({
  ...patient,
  ...(patient.deceased_at
    ? {
      deceased_at_pretty: d(getDobFromISOString(patient.deceased_at), 'shortMonth')
    }
    : {}),
  ...(patient.date_of_birth
    ? {
      date_of_birth_pretty_short_month: d(getDobFromISOString(patient.date_of_birth), 'shortMonth')
    }
    : {}),
  isMuted: !!patient.deceased_at
})));
const selectedStyle = {
  label: 'text-gray-900',
  total: 'text-white bg-primary-500 rounded'
};
const unselectedStyle = {
  label: 'text-gray-500',
  total: 'text-gray-500 bg-gray-200 rounded-md'
};

const getGender = (gender: string) => genderOptions().find((option) => option.value === gender)?.label;
const select = (index: number) => {
  emit('update-search-type', index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.searchResult, (result, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "cursor-pointer select-none",
          "data-cy": result.label,
          onClick: ($event: any) => (select(index))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["font-semibold text-xl", __props.searchTypeIndex === index ? selectedStyle.label : unselectedStyle.label])
            }, _toDisplayString(result.label), 3),
            (__props.searchTypeIndex === index && __props.showPatientResultsTable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex items-center justify-center p-1 text-2xs font-semibold", selectedStyle.total])
                }, _toDisplayString(result.rows.length), 3))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_2))
      }), 128))
    ]),
    (__props.showPatientResultsTable)
      ? (_openBlock(), _createBlock(DataTable, {
          key: 0,
          loading: __props.loading,
          columns: columns,
          rows: tableRows.value,
          "custom-heading-style": "background-color: rgba(61, 71, 107, 0.03);padding-top: 1rem;padding-bottom: 1rem;border-radius: 0.5rem;",
          "no-data-message": _ctx.$t('custom.uhb.patient.external-lookup-no-patients-found'),
          class: "w-full mt-4"
        }, {
          "cell.patient": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(`${row.last_name.toUpperCase()}, ${row.first_name}`), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(`${getGender(row.gender)}, ${row.age} years (${row.date_of_birth_pretty_short_month})`), 1)
              ])
            ])
          ]),
          "cell.ids": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_8, [
              (!isPDSSearch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('custom.uhb.patient.mrn-hospital-alias')), 1),
                    _createElementVNode("div", null, _toDisplayString(row.mrn), 1)
                  ]))
                : _createCommentVNode("", true),
              (row.external_patient_references)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", null, _toDisplayString(row.nhs_number), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          "cell.postcode": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_13, _toDisplayString(row.fhir_address ? row.fhir_address.postalCode : ''), 1)
          ]),
          "cell.buttons": _withCtx(({ row }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-end", { 'space-x-2': !row.isMuted }])
            }, [
              (row.deceased_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_unref(MedKitBadge), {
                      kind: "stable",
                      size: "small",
                      tint: "",
                      label: 
                _ctx.$t('custom.uhb.patient.deceased-at', {
                  deceasedDate: row.deceased_at_pretty
                })
              
                    }, null, 8, ["label"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(BaseButton, {
                      class: "rounded-lg text-gray-600",
                      color: "ghost",
                      onClick: ($event: any) => (_ctx.$emit('view-patient', row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.common.view')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(BaseButton, {
                      class: "rounded-lg ml-2",
                      color: "ghost",
                      "right-icon": "arrow-right",
                      onClick: ($event: any) => (_ctx.$emit('select-patient', row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.common.select')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
            ], 2)
          ]),
          _: 1
        }, 8, ["loading", "rows", "no-data-message"]))
      : _createCommentVNode("", true)
  ]))
}
}

})